import { Block, Website } from 'src/app/apps/website/interfaces/PagesCategories';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as g from '../../globals';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class GlobalWebsiteService {
  publicUrl = '';
  private pagesSource = new BehaviorSubject<any>([]);
  pages = this.pagesSource.asObservable();
  assignPages(pages: any[]) {
    this.pagesSource.next(pages);
  }
  private websiteSource = new BehaviorSubject<any>(null);
  website = this.websiteSource.asObservable();
  assignWebsite(website: Website) {
    this.websiteSource.next(website);
  }
  private _headerBlock: Block;

  public set headerBlock(v: Block) {
    this._headerBlock = v;
  }

  public get headerBlock(): Block {
    return this._headerBlock;
  }

  private _footerBlock: Block;
  public get footerBlock(): Block {
    return this._footerBlock;
  }
  public set footerBlock(v: Block) {
    this._footerBlock = v;
  }

  // private _website: Website;
  // public get website(): Website {
  //   return this._website;
  // }
  // public set website(v: Website) {
  //   this._website = v;
  // }


  constructor(
    private http: HttpClient
  ) {
    this.publicUrl = `${g.apiBaseUrl}PublicWebsites/`;
  }

  getDefaultWebsite() {
    return this.http.get(`${this.publicUrl}GetDefaultWebsite`);
  }
  getPageById(id: number) {
    return this.http.get(`${this.publicUrl}GetPageById?id=${id}`);
  }
  getBlocksByIds(ids: number[]) {
    let idsStr = '';
    ids.forEach(id => { idsStr += `ids=${id}&`; });
    if (idsStr.endsWith('&')) {
      idsStr = idsStr.slice(0, -1);
    }
    return this.http.get(`${this.publicUrl}GetBlocks?${idsStr}`);
  }
  getPagesByWebsiteId(id: number) {
    return this.http.get(`${this.publicUrl}GetPagesOfWebsite?websiteId=${id}`);
  }
}
